export default "/images/equipnent_placeholder.png?4994d8b7636dba96e8b063e50e2b4869";